import React from "react"
import SectionTitle from "./sectionTitle"
import { Box, Container, Flex, Grid, Text } from "@theme-ui/components"
import ImageGallery from "./imageGallery"

const TextWithImageBlock = ({ section }) => (
  <Box
    sx={{
      backgroundImage: section.dark
        ? "linear-gradient(90deg, #1D1D1B, #1D1D1B)"
        : "linear-gradient(90deg, #fafafa, #fafafa)",
      backgroundSize: ["100% 100%", "55% 100%"],
      backgroundPosition: section.alignement === "left" ? "0 100%" : "100% 0",
      backgroundRepeat: "no-repeat",
    }}
    mt={[0, 5]}
    mb={[0, 5]}
  >
    <Container sx={{ paddingY: [3, 5] }}>
      <Grid
        columns={[1, 2, section.alignement === "right" ? "4fr 3fr" : "3fr 4fr"]}
        gap={[5]}
      >
        <Flex sx={{ flexDirection: "column", justifyContent: "center" }}>
          {section.label && (
            <Text sx={{ fontSize: 1, color: "primary", mb: 3 }}>
              {section.label}
            </Text>
          )}
          <SectionTitle
            title={section.title}
            alignement="left"
            dark={section.dark}
          />
          <Box
            sx={{ color: section.dark ? "light" : "inherit" }}
            dangerouslySetInnerHTML={{ __html: section.body }}
          />
        </Flex>
        <Box
          sx={{
            justifyContent: "center",
            alignItems: "center",
            order: [null, section.alignement === "right" ? "-1" : null],
            div: {
              flexGrow: 1,
            },
          }}
        >
          <ImageGallery images={section.imageGallery} />
        </Box>
      </Grid>
    </Container>
  </Box>
)

export default TextWithImageBlock
